import { AddBranches } from "../components/addBranches";
import AddParentToChild from "../components/addParenttoChild";
import Branches from "../components/branches/Branches";
import GroupBusinesses from "../components/businessgroup/BusinessGroups";
import CreateBusinessGroup from "../components/businessgroup/CreateBusinessGroup";
import Orgsmap from "../components/Orgsmap";
import { ParentOrgForm } from "../components/ParentOrganizationForm";
import { RootOrgForm } from "../components/rootOrganizationForm";
import { Adduser } from "../components/users/Adduser";
import UserList from "../components/users/UserList";
import MainOraganizations from "../dashboard/MainOrganizations";
import Dashboardnav from "../sidenav-dashboard/Dashboard";
import Statistics from "../components/Statistics";
import { FullLayout } from "../dashboard/Organization_FullLayout";
import { DetailPage } from "../dashboard/detailPage";
import { Notifications } from "../dashboard/Notifications";
import ChildOragnizations from "../dashboard/ChildOrganizations";
import History from "../dashboard/History";
import { GenerateReport } from "../dashboard/GenerateReport";
import { LazilyRenderNodes } from "../dashboard/LazilyRenderNodes";
import NotFound from "./NotFound";
import Profile from "./Profile";

export const ThemeRoutes = (admin) => [
  {
    path: "/",
    element: <Dashboardnav />,
    children: [
      {
        path: "UltimateHoldingCompany",
        element: <MainOraganizations />,
      },
      {
        path: "GroupCompanies",
        element: <ChildOragnizations />,
      },
      {
        path: "dropdown/root",
        element: <RootOrgForm />,
      },
      {
        path: "dropdown/parent",
        element: <ParentOrgForm />,
      },
      {
        path: "AddParentToChild",
        element: <AddParentToChild />,
      },
      ...(admin?.permissions?.addOrganization
        ? [
          {
            path: "AddBranches",
            element: <AddBranches />,
          },
        ]
        : []),
      {
        path: "branches",
        element: <Branches />,
      },
      {
        path: "orgmap",
        element: <Orgsmap />,
      },

      ...(admin?.userRole === "Admin"
        ? [
          {
            path: "Createbusinessgroup",
            element: <CreateBusinessGroup />,
          },
          {
            path: "groupbusinesses",
            element: <GroupBusinesses />,
          },
        ]
        : []),
      ...(admin?.permissions?.showUser
        ? [
          {
            path: "userList",
            element: <UserList />,
          }

        ]
        : []),
      {
        path: "Createuser",
        element: <Adduser />,
      },
      {
        path: "stats",
        element: <Statistics />,
      },
      {
        path: "Organisational-Chart",
        element: <FullLayout />,
      },
      {
        path: "organization-details",
        element: <DetailPage />,
      },
      {
        path: "notifications",
        element: <Notifications />,
      },

      ...(admin?.userRole === "Admin"
        ? [
          {
            path: "history",
            element: <History />,
          }

        ]
        : []),
      {
        path: "generate-report",
        element: <GenerateReport />,
      },
      {
        path: "lazily-render-nodes",
        element: <LazilyRenderNodes />,
      },
      {
        path: "profile",
        element: <Profile />,
      },
      {
        path: "*",
        element: <NotFound />,
      },
    ],
  },
];

